import { Flex } from '@chakra-ui/react'
import { Formik } from 'formik'

import VerifyMobileForm from './Form'

const INITIAL_VALUES = {
    countryCode: '+91',
    mobile: '',
    otp: '',
}

const VerifyMobile = ({
    title = 'Enter your mobile number to get OTP',
    onMobileChange = () => {},
    onOtpChange = () => {},
    onOtpVerified = () => {},
}) => {
    return (
        <Formik initialValues={INITIAL_VALUES}>
            <Flex
                alignItems="start"
                flexDirection="column"
                as="form"
                flexGrow={1}
            >
                <VerifyMobileForm
                    title={title}
                    onMobileChange={onMobileChange}
                    onOtpChange={onOtpChange}
                    onOtpVerified={onOtpVerified}
                />
            </Flex>
        </Formik>
    )
}

export default VerifyMobile
